import React from 'react';
import {observer, inject, IReactComponent, Provider} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {IHistoryStore} from './history.stores';
import {IAppRootStore} from '../../app.root.store';
import HistoryLayout from './HistoryLayout';
import {History} from './History';

interface HistoryViewProps {
    historyStore: IHistoryStore;
    rootStore: IAppRootStore;
}

@observer
export class HistoryViewComponent extends TechseeBaseComponent<HistoryViewProps> {
    renderInternal(): JSX.Element {
        const {historyStore} = this.props;
        const ctrl = historyStore.historyController;

        return (
            <Provider historyController={ctrl}>
                <HistoryLayout controller={ctrl}>
                    <History />
                </HistoryLayout>
            </Provider>
        );
    }
}

export const HistoryView = inject('rootStore', 'historyStore')(HistoryViewComponent) as IReactComponent;
